import { render, staticRenderFns } from "./EmojiRating.vue?vue&type=template&id=0acf05f4"
import script from "./emoji-rating.ts?vue&type=script&lang=ts&external"
export * from "./emoji-rating.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports